import FooterContent from "../../components/FooterContent";
import Header from "../../components/Header";
import SignIn from "../../components/SignIn";

function Login() {

    return(
        <>
            <Header/>
            <SignIn/>
            <FooterContent/>
        </>
    )
}
export default Login;